import styles from "./TecnicosPage.module.css"
import { useState, useEffect } from "react";
import HeaderPage from "../../components/HeaderPage";
import SearchBar from "../../components/SearchBar";
import MiniCardUser from "../../components/MiniCardUser"
import Tecnico from "../../components/Tecnico";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { deleteTecnico, getTecnicos } from "../../api/tecnicos.api";
import FormTecnico from "../../components/FormTecnico";
import ModalDataTec from "../../components/ModalDataTec";
import AlertDelete from "../../components/AlertDelete";
import FormEditTecnico from "../../components/FormEditTecnico";
import { check } from "../../api/users.api";
import { useNavigate } from "react-router-dom";

function TecnicosPage() {
    const [tecnicos, setTecnicos] = useState([]);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [tecIdSelect, setTecIdSelect] = useState("")
    const [isOpenDetails, setIsOpenDetails] = useState(false)
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isOpenAlert, setIsOpenDelete] = useState(false);


    function verDetalhes(thisEntityId) {
        setTecIdSelect(thisEntityId)
        setIsOpenDetails(true);
    }

    const navigate = useNavigate()

    useEffect(() => {
        check()
            .then(() => {
                getTecnicos()
                    .then(res => setTecnicos(res.data))
                    .catch((error) => {
                        setTecnicos([]);
                        if (error.response.status === 401) {
                            return toast.error("Não autorizado!");
                        } else if (error.response.status != 200) {
                            return toast.error("Erro! Verificar com suporte");
                        }
                    });
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login")
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }, []);

   const entity = tecnicos.find(tecnico => tecnico.id === tecIdSelect)



    const filteredTecnicos = Array.isArray(tecnicos) ? tecnicos.filter(tecnico =>
        tecnico.name.toLowerCase().includes(search.toLowerCase()) ||
        tecnico.number.toLowerCase().includes(search.toLowerCase()) ||
        tecnico.email.toLowerCase().includes(search.toLowerCase()) ||
        tecnico.setor.toLowerCase().includes(search.toLowerCase()) ||
        tecnico.car?.placa?.toLowerCase().includes(search.toLowerCase())
    ) : []

    return (
        <main className={styles.container}>
            <section className={styles.containerOne}>
                <HeaderPage
                    title="Técnicos"
                    textTitle="Gerencie sua frota de veículos"
                    textBtn="Técnico"
                    setIsOpen={() => setIsOpen(true)}
                />
                <MiniCardUser
                    text="Total de Técnicos"
                    data={tecnicos.length}
                />
                <SearchBar setSearch={setSearch} />
            </section>
            <section className={styles.cards}>
                {filteredTecnicos.map(tec => {
                    return <Tecnico thisTecnico={tec} key={tec.id} verDetalhes={verDetalhes} />
                })}
            </section>

            {isOpen && (
                <FormTecnico setIsOpen={setIsOpen} setTecnicos={setTecnicos} />
            )}

            {isOpenDetails && (
                <ModalDataTec setIsOpen={setIsOpenDetails} thisTec={entity} setIsOpenEdit={setIsOpenEdit} setIsOpenDelete={setIsOpenDelete} />
            )}

            {isOpenAlert && (
                <AlertDelete setIsOpen={setIsOpenDelete} entity={entity} func={deleteTecnico} />
            )}

            {isOpenEdit && (
                <FormEditTecnico setIsOpen={setIsOpenEdit} entity={entity} />
            )}
        </main>
    )
}

export default TecnicosPage;